import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';

export class CacheBustTranslateLoader implements TranslateLoader {
  private http = inject(HttpClient);

  public getTranslation(lang: string): Observable<Record<string, string>> {
    return this.http.get<Record<string, string>>(
      `/assets/i18n/${lang}.json`,
      { params: { 'nocache': Date.now().toString() } }
    );
  }
}
